<template>
    <div v-if="warning">
        <div class="bg-yellow-100 px-3 py-2 text-yellow-900 rounded-md relative text-sm shadow">
            <div class="w-8 overflow-hidden inline-block absolute left-2 top-0 -mt-4">
            <div class=" h-5 w-5 bg-yellow-100 rotate-45 transform origin-bottom-left"></div>
            </div>
            <fa :icon="['fas', 'exclamation-triangle']" class="mr-2" />
            {{ warning }}
        </div>
    </div>
</template>

<script>

export default {
    props: ['warning'],

    setup(props) {
        return {};
    },
};
</script>